module.exports = __webpack_public_path__ + "static/media/timed-bonus-chest-open.10d8a8fd.png";